import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import { login } from './actions';

import LoginCaptchaForm from 'forms/LoginCaptchaForm'
import InputField from 'forms/InputField';
import Box from 'common/Box';
import Warning from 'notifications/Warning';
import { getShowVerificationCode, getLoginTimerTime, getForceShowVerification, getMdnValid } from '../../reducers';
import styles from "../../forms/forms.module.css";

export const LoginForm = (props) => (
  <div className="LoginForm">
    <Box>
      <LoginCaptchaForm {...props} submit={'Sign In'}>
        <Field name="email" component={InputField} />
        <Field name="password" component={InputField} type="password" />
      </LoginCaptchaForm>
    </Box>
    {!props.showVerificationCode && !props.forceShowVerification &&
      <Warning name="login" />
    }
  </div>
);

const mapStateToProps = state => {
  const selector = formValueSelector('login');
  const values = selector(state, 'email', 'password', 'verification_code', 'recaptcha_token', 'device_uuid', 'code_sending_mode', 'target_mdn');
  return {
    showVerificationCode: getShowVerificationCode(state),
    forceShowVerification: getForceShowVerification(state),
    timerTime: getLoginTimerTime(state),
    mdnValid: getMdnValid(state),
    values,
  }
};

export default reduxForm({
  form: 'login',
  onSubmit: login,
})(connect(mapStateToProps)(LoginForm));
